export const environment = {
  production: true,
  emulator: false,
  mock: false,
  stripeKey: '',
};
